import { h } from "@stencil/core";
import { PrefillData } from "../../../api/publicApi/createCase/createCase";

interface DescriptionInputProps {
    t: (key: string) => string;
    prefillData: PrefillData | null;
}

export const DescriptionInput = ({ t, prefillData }: DescriptionInputProps) => (
    <ux-textarea-field
        label={t("field.message.label")}
        placeholder={t("field.message.placeholder")}
        value={prefillData?.description || ""}
        required
        data-validation-required--msg={t("validation.requiredField")}
        name="description"
    ></ux-textarea-field>
);
